export function getMonthlyInterestCost(interestRate: number, loanAmount: number) {
  return Math.round((interestRate * loanAmount) / 100 / 12)
}

export function getMonthlyInterestCostWithTaxDeduction(interestRate: number, loanAmount: number) {
  const interestCostPerMonth = getMonthlyInterestCost(interestRate, loanAmount)
  const annualInterestCost = interestCostPerMonth * 12
  let annualInterestCostAfterDeduction
  if (annualInterestCost <= 100_000) {
    annualInterestCostAfterDeduction = annualInterestCost * 0.7
  } else {
    const deductionForUpTo100K = 100_000 * 0.3
    const deductionForOver100K = (annualInterestCost - 100_000) * 0.21
    annualInterestCostAfterDeduction =
      annualInterestCost - (deductionForUpTo100K + deductionForOver100K)
  }
  return Math.round(annualInterestCostAfterDeduction / 12)
}
